<app-kpi-details-dialog title="Detalle por semanas" [subtitle]="subtitle">
  @if (data.weeks.length === 0) {
    <p class="no-data">No hay datos disponibles</p>
  } @else {
    <div class="weeks-list">
      @for (week of data.weeks; track week.start_date) {
        <div class="week-item" [class.week-item--ok]="week.is_compliant" [class.week-item--fail]="!week.is_compliant">
          <div class="week-header">
            <div class="week-title">
              <span class="week-status-dot" [style.background-color]="weekColor(week)"></span>
              <span class="week-label">{{ week.label }}</span>
            </div>
            <span class="week-hours">
              {{ week.done_hours | number: '1.1-1' }}h / {{ week.expected_hours | number: '1.1-1' }}h ·
              {{ week.percentage | number: '1.0-0' }}%
            </span>
          </div>

          @if (week.categories.length === 0) {
            <p class="no-categories">Sin horas esperadas esta semana</p>
          } @else {
            <div class="categories-list">
              @for (category of week.categories; track category.name) {
                <div class="category-item">
                  <div class="category-header">
                    <span class="category-name">
                      {{ category.name }}
                      @if (category.is_company_product) {
                        <span class="category-tag">Producto</span>
                      }
                    </span>
                    <span class="category-hours">
                      {{ category.done_hours | number: '1.1-1' }}h / {{ category.expected_hours | number: '1.1-1' }}h
                    </span>
                  </div>

                  <div class="progress-bar-container">
                    <div class="progress-bar-track">
                      <div
                        class="progress-bar-fill"
                        [style.width.%]="category.percentage"
                        [style.background-color]="categoryColor(category)"
                      ></div>
                    </div>
                    <div class="progress-bar-labels">
                      <span class="value">{{ category.percentage | number: '1.0-0' }}%</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</app-kpi-details-dialog>
